import React, { Component } from 'react';
import { connect } from 'react-redux';
import DateSearch from './DateSearch';
import { Row, Col, Input, DatePicker } from 'antd';
import { updateChckInQueryInfo } from '../../actions/checkInAction';
import intl from 'react-intl-universal';
import moment from 'moment';
import Icon from '../Iconfont';
import style from './index.less';
import { initalCheckQuery } from './checkInfo';
import {setStartDate} from '../../utils/dateUtils'
const { Search } = Input;
const { RangePicker } = DatePicker;
class CheckIn extends Component {
  constructor(props) {
    super();
    this.state = {
      searchValue: props.queryInfo.fuzzy
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.queryInfo.fuzzy !== this.props.queryInfo.fuzzy) {
      this.setState({
        searchValue: this.props.queryInfo.fuzzy
      });
    }
  }
  changeDataRange(data) {
    let p = {
      page: 0,
      registrate_from: data.From,
      registrate_to: data.To
    };
    this.props.updateChckInQueryInfo(p);
  }

  changeDate(value, dateString) {
    let p = {
      page: 0,
      registrate_from: dateString[0],
      registrate_to: dateString[1]
    };
    this.props.updateChckInQueryInfo(p);
  }
  changeFuzzy = (e) => {
    this.setState({
      searchValue: e.target.value
    });
  };
  onSearch = (value) => {
    this.props.updateChckInQueryInfo({ page: 0, fuzzy: value });
  };
  resetQuery() {
    this.props.updateChckInQueryInfo({ ...this.props.queryInfo, ...initalCheckQuery });
    this.setState({ searchValue: '' });
  }
  disabledDate(current) {
    return setStartDate(current)
  }
  render() {
    const { queryInfo } = this.props;
    const { searchValue } = this.state;
    let timeList =
      queryInfo.registrate_from !== '' && queryInfo.registrate_to !== ''
        ? [moment(queryInfo.registrate_from), moment(queryInfo.registrate_to)]
        : null;
    return (
      <Row gutter={30} style={{ marginLeft: 0, marginRight: 0 }}>
        <Col span={6}>
          <Search
            placeholder={intl.get('SEARCH_TEXT')}
            value={searchValue}
            onChange={this.changeFuzzy}
            onSearch={this.onSearch}
          />
        </Col>
        <Col span={8}>
          <RangePicker
            disabledDate={this.disabledDate.bind(this)}
            showTime={{
              format: 'HH:mm',
              defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
            }}
            value={timeList}
            onChange={this.changeDate.bind(this)}
            style={{ width: '100%' }}
          />
        </Col>
        <Col span={10} className={style.search_right}>
          <DateSearch
            parent={this}
            dateRange={{ From: queryInfo.registrate_from, To: queryInfo.registrate_to }}
          />
          <span onClick={this.resetQuery.bind(this)}>
            <Icon type="icon-fresh" />
          </span>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    queryInfo: state.checkIn.queryInfo
  };
};

export default connect(mapStateToProps, { updateChckInQueryInfo })(CheckIn);
